import React from 'react';
import t from 'react-translate';

import NvIcon from 'shared/components/nv-icon';
import { TOPICS_CSV_DOWNLOAD_HELP_ARTICLE } from 'institutions/components/help-options-settings/additional-resources/constants';
import TopicsCSVPicker from './topics-csv-picker';

interface UploadTopicsProps {
  onConfirmTopics: (topics: string[]) => void;
}

const UploadTopics: React.FC <UploadTopicsProps> = ({ onConfirmTopics }) => (
  <div className='d-flex flex-column align-items-center'>
    <div className='text-body mb-8'>
      {t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.TOPICS_DESCRIPTION(TOPICS_CSV_DOWNLOAD_HELP_ARTICLE)}
    </div>
    <TopicsCSVPicker
      onConfirmTopics={onConfirmTopics}
    >
      <div
        className='d-flex bg-primary justify-content-center align-items-center text-white px-3 py-2 rounded cursor-pointer font-weight-bold'
      >
        <NvIcon icon='upload' size='smallest' className='mr-2' />
        <span>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN.UPLOAD_CSV()}
        </span>
      </div>
    </TopicsCSVPicker>
  </div>
);

export default UploadTopics;
